/**
 * Service for the Integration-Agent import-history view (#1936).
 *
 * Reads the tenant-facing observed-imports aggregate: per Erntejahr, the
 * workbook the browser-extension backfill uploaded, its ingest status, and the
 * count of currently-linked twin entities. One GET, folded server-side.
 */
import api from './api';

/** Per-year import row. Nullable fields are honest — the server reports only
 * what actually landed (year-less rows sink last; `entity_counts` is null when
 * the per-doc entity lookup failed transiently). */
export interface AgentImport {
  year: string | null;
  doc_id: string | null;
  filename: string | null;
  /** Document ingest status — drives the per-year status badge. */
  status: string | null;
  uploaded_at: string | null;
  /** `{entity_type: count}` of currently-linked twin objects, or null. */
  entity_counts: Record<string, number> | null;
}

export interface AgentImportsResponse {
  source: string;
  imports: AgentImport[];
}

export const integrationAgentService = {
  /**
   * List observed imports for a source (default `myfarm24`).
   *
   * Path mirrors the twin services (`/v1/...`) so the BFF's generic catch-all
   * (`/api/v1/{path}`) proxies it — no BFF route needed. GET is CSRF-free.
   */
  listImports: async (source: string = 'myfarm24'): Promise<AgentImportsResponse> => {
    const response = await api.get<AgentImportsResponse>('/v1/integrations/agent/imports', {
      params: { source },
    });
    return response.data;
  },
};
